import React, { useState } from "react";
// import { Link } from "react-router-dom";
import DescriptionIcon from '@mui/icons-material/Description';
import DownloadIcon from '@mui/icons-material/Download';
import "../components/styles/startUpDetails.css";
import { callApi } from "../common/api";
// import HandIcon from "../components/Icons/hand-holding-dollar-solid.svg";
import Box from "@mui/material/Box";
import CustomizedSnackbars from "../components/alert/alert";
import Loader from "../common/components/Loader";
import { Link, animateScroll as scroll } from "react-scroll";
import Backdrop from '@mui/material/Backdrop';
import Modal from '@mui/material/Modal';
import Typography from '@mui/material/Typography';
import ReactMarkdown from 'react-markdown';
// import DOMPurify from 'dompurify';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import WatchlistPay from "./Investor/WatchlistPay";
import Markdown from "react-markdown";
const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
    padding: "0px 13px 26px 24px"
};

const StartUpDetails = () => {
    const startupId = JSON.parse(localStorage.getItem("startUpId"))
    const [content, setContent] = useState({});
    console.log(content)
    const [open, setOpen] = React.useState(false);
    const [payment, setPayment] = useState(false);
    const [activeLink, setActiveLink] = useState(null);
    const [kycStatus, setKycStatus] = React.useState("")
    console.log(payment)
    console.log(kycStatus>=1)
    console.log(payment && kycStatus >= 1 )


    const [state, setState] = React.useState("")
    // const cleanText = (text) => {
    //     return text
    //       .replace(/\s+/g, ' ')  // Replace multiple spaces with a single space
    //       .replace(/\s*\.\s*/g, '. ')  // Ensure single space after periods
    //       .replace(/\s+,/g, ',')  // Remove spaces before commas
    //       .replace(/\s*:\s*/g, ': ')  // Ensure single space after colons
    //       .replace(/\s*;\s*/g, '; ')  // Ensure single space after semicolons
    //       .trim();  // Remove leading and trailing spaces
    //   };

    const handleOpen = async (startUpid) => {
        const dealId = JSON.parse(localStorage.getItem("dealId"))
        const obj = {
            startupDealId: dealId,
            source: 0
        }
        await callApi("post", "lead/createLead", obj)
        setState(startUpid)
        setOpen(true);
    }
    const handleClose = () => setOpen(false);

    const getPaymentData = async () => {
        const response = await callApi("get", "investor/getPayment")
        setPayment(response?.data?.response?.data?.isPaymentDone)
    }

    const [snackBarMsg, setSnackBarMsg] = useState({
        message: "",
        severity: "success",
        open: false,
    });

    const [loader, setLoader] = React.useState(false);

    const getAllContent = async () => {
        try {
            const getStartUpId = JSON.parse(localStorage.getItem('dealId'));
            if (getStartUpId != null) {
                const response = await callApi("get", `startup/startupDealsDetails?id=${getStartUpId}`);
                if (response.data.status) {
                    setSnackBarMsg({
                        message: response.data.message,
                        severity: "success",
                        open: true
                    })
                }
                return response.data.response.data;
            }
        } catch (error) {
            console.log(error)
            if (error.response) {
                // The request was made, but the server responded with an error status
                setSnackBarMsg({
                    message: error.response.data.message,
                    severity: "error",
                    open: true,
                });
                // You can handle specific HTTP error codes here if needed
            } else if (error.request) {
                // The request was made, but no response was received
                setSnackBarMsg({
                    message: "An error occurred while processing your request.",
                    severity: "error",
                    open: true,
                });
            } else {
                // Something happened in setting up the request that triggered an Error
                setSnackBarMsg({
                    message: "something went wrong",
                    severity: "error",
                    open: true,
                });
            }
        }

    }

    const AddToWatchlist = async () => {
        setLoader(true)
        const id = JSON.parse(localStorage.getItem("startUpId"));
        const dealId = JSON.parse(localStorage.getItem("dealId"))
        const data = {
            startupId: id
        }
        const obj = {
            startupDealId: dealId,
            source: 0
        }
        try {
            const response = await callApi("post", "watchList/createWatchList", data, { "Content-Type": "application/json" }, true, true);
            await callApi("post", "lead/createLead", obj)
            if (response.status) {
                setSnackBarMsg({
                    message: "Added to Watchlist Successfully",
                    severity: "success",
                    open: true
                })
            }
            if (response.data.response.status === false) {
                setSnackBarMsg({
                    message: "This startup is already exist in your watchlist",
                    severity: "error",
                    open: true
                })
            }
        
        } catch (error) {
            console.log(error)
        } finally {
            setLoader(false)
        }
    }

    async function getDetails() {
        try {
            const response = await callApi('get', 'userRegister')
            const data = response.data.response.data
            setKycStatus(data?.kycStatus)

        } catch (error) {
            console.log(error, "error")
        }
    }

    React.useEffect(() => {
        getAllContent().then((v) => {
            setContent(v);
        });
        getPaymentData()

    }, []);

    React.useEffect(() => {
        getDetails()
        getPaymentData()
    }, [open])

    const handleBack = () => {
        if (!startupId) {
            window.location.href = "/ongoingDeals"
        }
        else {
            window.location.href = "/allstartups"

        }
    }
 
    return (
        <>
            {!content || Object.keys(content).length === 0 ? <Loader /> : (
                <div>
                    <Modal
                        aria-labelledby="transition-modal-title"
                        aria-describedby="transition-modal-description"
                        open={open}
                        onClose={handleClose}
                        closeAfterTransition
                        slots={{ backdrop: Backdrop }}
                        slotProps={{
                            backdrop: {
                                timeout: 500,
                            },
                        }}
                    >
                        {/* <Fade in={open}>
                            <Box sx={style}>
                                <ScheduleMeetingComponent closeButton={handleClose}/>
                            </Box>
                        </Fade> */}
                        <Box
                            sx={{
                                position: "fixed",
                                top: "50%",
                                left: "50%",
                                transform: "translate(-50%, -50%)",
                                overflowY: "auto",
                                overflowX: "hidden",
                                maxHeight: "100vh",
                                width: "100%",
                            }}

                        >
                            <WatchlistPay handleClose={handleClose} sid={state} />
                        </Box>
                    </Modal>
                    <strong><hr /></strong>
                    <CustomizedSnackbars
                        msgData={snackBarMsg}
                        setMsgData={setSnackBarMsg}
                    />
                    <div id="startup-container" className="container">
                        <div id="upar">
                            <div className="left">
                                <KeyboardBackspaceIcon sx={{ cursor: 'pointer' }} onClick={handleBack} />
                                <img className="logo" src={content?.resource?.basicDetails?.companylogo?.link} alt="Incred" />
                                <p style={{ marginTop: "22px" }}>{content?.resource?.dealTitle}</p>
                                <img className="logo1" src={content?.resource?.basicDetails?.banner?.link} alt="youtube" />

                                <Box className="basic-details">
                                    {content?.resource?.basicDetails?.dealType == 0 ?
                                        <>
                                            <div className="basic-details-row">
                                                <Typography className="basic-details-value">{content?.resource?.basicDetails?.fundingRound ? content?.resource?.basicDetails?.fundingRound : "--"}</Typography>
                                                <Typography className="basic-details-menu">Funding Round</Typography>
                                            </div>
                                            {/* <div className="basic-details-row">
                                                <Typography className="basic-details-value">{content?.resource?.basicDetails?.leadInvestor ? content?.resource?.basicDetails?.leadInvestor : "--"}</Typography>
                                                <Typography className="basic-details-menu">Lead Investor</Typography>
                                            </div> */}
                                            <div className="basic-details-row">
                                                <Typography className="basic-details-value">{content?.resource?.basicDetails?.totalValue ? content?.resource?.basicDetails?.totalValue : "--"}</Typography>
                                                <Typography className="basic-details-menu">Investment Amount</Typography>
                                            </div>
                                        </>
                                        : content?.resource?.basicDetails?.dealType == 1 ?
                                            <>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.yield ? content?.resource?.basicDetails?.yield : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Yield of Maturity</Typography>
                                                </div>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.time ? content?.resource?.basicDetails?.time : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Time of Maturity</Typography>
                                                </div>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.totalValue ? content?.resource?.basicDetails?.totalValue : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Total Value</Typography>
                                                </div>

                                            </>
                                            : 
                                            <>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.sale ? content?.resource?.basicDetails?.sale : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Rate Sale</Typography>
                                                </div>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.margin ? content?.resource?.basicDetails?.margin : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Ebitda Margin</Typography>
                                                </div>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.worth ? content?.resource?.basicDetails?.worth : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Net worth</Typography>
                                                </div>
                                                <div className="basic-details-row">
                                                    <Typography className="basic-details-value">{content?.resource?.basicDetails?.totalValue ? content?.resource?.basicDetails?.totalValue : "--"}</Typography>
                                                    <Typography className="basic-details-menu">Ask Price</Typography>
                                                </div>

                                            </>
                                    }

                                    {/* <div className="basic-details-column">
                                        <Box className="basic-details-percentage">
                                            <svg style={{ marginBottom: "13px" }} xmlns="http://www.w3.org/2000/svg" width="167" height="2" viewBox="0 0 167 2" fill="none">
                                                <rect x="0.179688" width="166" height="2" rx="1" fill="#A9A9A9" />
                                                <rect x="0.179688" width={content ? (content.totalInvestedAmt / content.resource.totalValue * 100) : "0"} height="2" rx="1" fill="white" />
                                            </svg>
                                        </Box>
                                        <Typography className="basic-details-value">{(content?.totalInvestedAmt / content?.resource?.totalValue * 100).toFixed(2) + "%"}</Typography>
                                        <Box className="fund-raise">
                                            <Typography className="basic-details-menu">Total funds raised</Typography>
                                        </Box>
                                        
                                    </div> */}
                                </Box>
                            </div>
                            {startupId ?
                                <div className="right">
                                    <h1>Lorem ipsum dolor sit amet </h1>
                                    <p style={{ color: "#CCCACA" }}>Lorem ipsum dolor sit amet consectetur. Arcu semper est ut morbi.</p>
                                    <div className="d-flex justify-content-between w-100">

                                        <button style={{ cursor: "pointer", margin: "6px", fontWeight: 500, backgroundColor: "black", color: "white", border: "2px solid white" }} onClick={AddToWatchlist} className="startup-btn">{loader ? <><Loader /> Watchlist</> : "Watchlist"}</button>
                                        <button style={{ cursor: "pointer", fontWeight: 500 }} onClick={() => handleOpen(startupId)} className="startup-btn">{payment && kycStatus >= 1 ? "Select Timeslot" : !payment && kycStatus >= 1 ? "Pay" : "Invest"}</button>
                                    </div>
                                </div>
                                : <></>}
                        </div>
                        <div id="neeche">
                        <div className="headings">
                                 <ul>
                                     {content?.resource?.description && content?.resource?.description.map((des, index) =>
                                         <li key={index}>
                                             <Link
                                                 style={{ 
                                                     cursor: "pointer", 
                                                     color: activeLink === des.descriptionTitle || (index === 0 && !activeLink) ? "white" : "grey",
                                                     // fontWeight: activeLink === des.descriptionTitle ? "bold" : "normal" 
                                                 }}
                                                 activeClass="active"
                                                 to={des.descriptionTitle}
                                                 spy={true}
                                                 smooth={true}
                                                 offset={-70}
                                                 duration={500}
                                                 onClick={() => setActiveLink(des.descriptionTitle)}
                                             >
                                                 {des.descriptionTitle}
                                             </Link>
                                         </li>
                                     )}
                                     <li>
                                         <Link
                                             style={{ 
                                                 cursor: "pointer", 
                                                 color: activeLink === "Download" || (!activeLink && content?.resource?.description.length === 0) ? "white" : "grey",
                                                 // fontWeight: activeLink === "Download" ? "bold" : "normal" 
                                             }}
                                             activeClass="active"
                                             to="dload"
                                             spy={true}
                                             smooth={true}
                                             offset={-70}
                                             duration={500}
                                             onClick={() => setActiveLink("Download")}
                                         >
                                             Download
                                         </Link>
                                     </li>
                                 </ul>
                             </div>

                            <div className="details">
                                {content?.resource?.description && content?.resource?.description?.map((des, index) =>
                                    <div className="round-details" id={des.descriptionTitle} key={index}>
                                        <h2>{des.descriptionTitle}</h2>
                                        <hr />
                                        {/* <ReactMarkdown>{des.description}</ReactMarkdown> */}
                                        <div dangerouslySetInnerHTML={{ __html: des.description }}></div>
                                    </div>
                                )}   
                                {/* {content?.resource?.description && content.resource.description.map((des, index) => (
  <div className="round-details" id={des.descriptionTitle} key={index}>
    <h2>{cleanText(des.descriptionTitle)}</h2>
    <hr />
    {des.description.startsWith('<') ? (
      <div dangerouslySetInnerHTML={{ 
        __html: DOMPurify.sanitize(cleanText(des.description))
          .replace(/\n/g, '<br>')  // Replace newlines with <br> tags
      }} />
    ) : (
      <ReactMarkdown>{cleanText(des.description)}</ReactMarkdown>
    )}
  </div>
))} */}
                                   
                                <div className="download" id="dload">
                                    <h2>Download</h2>
                                    <hr />
                                    <a target="blank" href={content?.resource?.download?.pitchdeck?.link}>
                                        <div className="pitch">
                                            <div style={{ margin: '10px', width: '113px', justifyContent: 'space-between', display: 'flex' }}><DescriptionIcon /><span>Pitch Deck</span></div><DownloadIcon />
                                        </div>
                                    </a>
                                </div>
                                
                            </div>
                            {startupId ?
                                <div className="mobileOnlyInvest">
                                    <h4>Lorem ipsum dolor sit amet </h4>
                                    <p style={{ color: "#CCCACA" }}>Lorem ipsum dolor sit amet consectetur. Arcu semper est ut morbi.</p>
                                    <div className="d-flex justify-content-between w-100">
                                        <button style={{ cursor: "pointer", margin: "6px", fontWeight: 500, backgroundColor: "black", color: "white", border: "2px solid white" }} onClick={AddToWatchlist} className="startup-btn">{loader ? <><Loader /> Watchlist</> : "Watchlist"}</button>
                                        <button style={{ cursor: "pointer", fontWeight: 500 }} onClick={() => handleOpen(startupId)} className="startup-btn">{payment && kycStatus >= 1 ? "Select Timeslot" : !payment && kycStatus >= 1 ? "Pay" : "Invest"}</button>
                                        
                                    </div>
                                </div>
                                : <></>}
                        </div>
                    </div>
                </div>
            )}

        </>
    )
}

export default StartUpDetails;